import { Container, Label, Num } from './styled';

type BulletProps = {
  num: number;
  label: string;
};

export const Bullet = ({ label, num }: BulletProps) => {
  return (
    <Container>
      <Num>{num}</Num>
      <Label> {label}</Label>
    </Container>
  );
};
